<div class="container">
	<div class="track"></div>
	<div class="train"></div>
</div>